import type { OptionItem } from 'app/components/FormSelect';
import { CustomerInfoKeyType, JobTypeEnum } from 'types/customer';

/* --------------- 配置项 --------------- */
export const jobInfoOptions: Array<{
    value: JobTypeEnum;
    label: string;
}> = [
    {
        value: JobTypeEnum.Employed,
        label: __('Employed')
    },
    {
        value: JobTypeEnum.SelfEmployed,
        label: __('Self-Employed')
    },
    {
        value: JobTypeEnum.StudentOrIntern,
        label: __('Student/Intern')
    },
    {
        value: JobTypeEnum.Retired,
        label: __('Retired')
    },
    {
        value: JobTypeEnum.Homemaker,
        label: __('Homemaker')
    },
    {
        value: JobTypeEnum.Unemployment,
        label: __('Unemployed')
    },
    {
        value: JobTypeEnum.AtHomeTrader,
        label: __('At Home Trader')
    }
];

export const incomeTypes: Array<{
    id: string;
    type: string;
}> = [
    {
        id: '0',
        type: __('Consulting')
    },
    {
        id: '1',
        type: __('Disability')
    },
    {
        id: '2',
        type: __('Inheritance')
    },
    {
        id: '3',
        type: __('Interest')
    },
    {
        id: '4',
        type: __('Real Estate')
    },
    {
        id: '5',
        type: __('Rental')
    },
    {
        id: '6',
        type: __('Severance')
    },
    {
        id: '7',
        type: __('Spouse')
    },
    {
        id: '8',
        type: __('Trading & Investments')
    },
    {
        id: '9',
        type: __('Unemployment')
    },
    {
        id: '11',
        type: __('Retirement Pension / Social Security')
    },
    {
        id: '10',
        type: __('Other')
    }
];
export const incomeTypesOptions: OptionItem[] = incomeTypes.map(item => ({
    value: `${item.id}:100`,
    label: item.type
}));

/* --------------- 各个方法 --------------- */
export function getFieldsOfJobInfo(): CustomerInfoKeyType[] {
    return ['job', 'company', 'additional_source_income'];
}

/**
 * @description 受雇和自主创业需要提供单位信息
 */
export function getShowCompany(job: JobTypeEnum) {
    return [JobTypeEnum.Employed, JobTypeEnum.SelfEmployed].includes(job);
}

export function getShowAdditionalSourceIncome(job: JobTypeEnum) {
    return job >= JobTypeEnum.StudentOrIntern;
}
